import React from 'react';
import { Button, ButtonProps, Box } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';

interface BackButtonProps {
  label?: string;
  icon?: React.ReactNode;
  onGoBack?: () => void;
  variant?: 'text' | 'outlined' | 'contained' | 'gradient';
}

const BackButton: React.FC<BackButtonProps> = ({
  label = 'Go Back',
  icon,
  onGoBack,
  variant = 'gradient',
  ...buttonProps
}) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (onGoBack) {
      onGoBack();
    } else {
      navigate(-1);
    }
  };

  const gradientStyles = {
    position: 'relative',
    border: '1px solid transparent',
    borderRadius: '4px',
    background: 'white',
    backgroundClip: 'padding-box',
    color: 'transparent',
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      zIndex: -1,
      margin: '-1px',
      borderRadius: 'inherit',
      background: 'linear-gradient(90deg, #4AD06E 0%, #08B1B6 100%)',
    },
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.9)',
      '& .MuiButton-startIcon': {
        transform: 'translateX(-2px)',
      },
    },
    '& .MuiButton-startIcon': {
      transition: 'transform 0.2s ease',
    },
  };

  return (
    <Button
      startIcon={
        icon ?? (
          <ArrowBackIcon
            sx={{
              color: '#4AD06E',
            }}
          />
        )
      }
      onClick={handleClick}
      variant={variant === 'gradient' ? 'text' : variant}
      sx={{
        ...(variant === 'gradient' ? gradientStyles : {}),
        textTransform: 'none',
        fontWeight: 500,
      }}
      {...buttonProps}
    >
      {variant === 'gradient' ? (
        <Box
          component="span"
          sx={{
            background: 'linear-gradient(90deg, #4AD06E 0%, #08B1B6 100%)',
            WebkitBackgroundClip: 'text',
            backgroundClip: 'text',
            color: 'transparent',
          }}
        >
          {label}
        </Box>
      ) : (
        label
      )}
    </Button>
  );
};

export default BackButton;